var _rect, _g, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 144,
    viewBox: "0 0 458 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23023_30954",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 107
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 458,
    height: 107,
    rx: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23023_30954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 229,
    cy: -41,
    rx: 337,
    ry: 147,
    fill: "#FCE9EA"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 45.3711,
    width: 98,
    height: 98,
    rx: 49,
    fill: "#DA1E27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.295 84.6666L238.703 82.0742L228.999 91.7781L219.295 82.0742L216.703 84.6666L226.407 94.3704L216.703 104.074L219.295 106.667L228.999 96.9627L238.703 106.667L241.295 104.074L231.592 94.3704L241.295 84.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDialog);
export default __webpack_public_path__ + "static/media/deleteDialog.780f4c96da719079183f538d06cac87d.svg";
export { ForwardRef as ReactComponent };